module.exports = __webpack_public_path__ + "media/communication.37ee66b17ae222da7bfb726ceb797f2c.svg";